module.exports = __webpack_public_path__ + "img/calculadora icon.348b720d.svg";